import { render, staticRenderFns } from "./ObraServico.vue?vue&type=template&id=64964ddc&"
import script from "./ObraServico.vue?vue&type=script&lang=js&"
export * from "./ObraServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports